import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BEEHOME_API_URL, SERVER_URL } from 'src/app/config';
import { FeedbackInstantGiveAnswerDto, FeedbackInstantGiveDto, FeedbackInstantRequestDto } from 'src/app/dto/feedback-instant';
import { IFeedbackInstantGive } from 'src/app/interfaces/feedback-instant';
import { UtilService } from '../util/util.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackInstantService {
  private readonly httpClient = inject(HttpClient);
  private utilService = inject(UtilService);

  private urlRouteGive = 'feedbacks/instant/give';
  private urlRouteRequest = 'feedbacks/instant/request';

  // Give Feedback
  // Cutover Lambda (beehome-api-feedback, grupo INSTANT): SERVER_URL sozinho -> SERVER_URL + BEEHOME_API_URL.

  getFeedbackInstantGive(feedbackInstantGiveId: number): Observable<IFeedbackInstantGive> {
    return this.httpClient.get(`${SERVER_URL}${BEEHOME_API_URL}/${this.urlRouteGive}/${feedbackInstantGiveId}`).pipe(map((data: IFeedbackInstantGive) => data));
  }

  createFeedbackInstantGive(feedbackInstantGiveDto: FeedbackInstantGiveDto): Observable<any> {
    return this.httpClient.post(`${SERVER_URL}${BEEHOME_API_URL}/${this.urlRouteGive}/`, feedbackInstantGiveDto).pipe(map((data: any) => data));
  }

  updateFeedbackInstantGiveAsPublic(partialFeedbackInstantGiveDto: Partial<FeedbackInstantGiveDto>): Observable<IFeedbackInstantGive> {
    return this.httpClient.put(`${SERVER_URL}${BEEHOME_API_URL}/${this.urlRouteGive}/`, partialFeedbackInstantGiveDto).pipe(map((data: any) => data));
  }

  updateFeedbackInstantGiveAnswer(feedbackInstantGiveId: number, feedbackInstantGiveAnswerDto: FeedbackInstantGiveAnswerDto): Observable<IFeedbackInstantGive> {
    return this.httpClient.put(`${SERVER_URL}${BEEHOME_API_URL}/${this.urlRouteGive}/${feedbackInstantGiveId}/answers/`, feedbackInstantGiveAnswerDto).pipe(map((data: any) => data));
  }

  // Request Feedback

  createFeedbackInstantRequest(feedbackInstantRequestDto: FeedbackInstantRequestDto): Observable<any> {
    const httpParams: HttpParams = new HttpParams().append('userZone', this.utilService?.userZone);
    return this.httpClient.post(`${SERVER_URL}${BEEHOME_API_URL}/${this.urlRouteRequest}/`, feedbackInstantRequestDto, { params: httpParams }).pipe(map((data: any) => data));
  }

  updateFeedbackInstantGive(feedbackInstantRequestId: number, feedbackInstantGiveDto: FeedbackInstantGiveDto): Observable<any> {
    return this.httpClient.put(`${SERVER_URL}${BEEHOME_API_URL}/${this.urlRouteRequest}/${feedbackInstantRequestId}/answers/`, feedbackInstantGiveDto).pipe(map((data: any) => data));
  }
}
